import { AIProvider } from "./AIProvider";
import { IntegrationsProvider } from "./IntegrationsProvider";
import { ThemeProvider } from "./ThemeProvider";
import { UserProvider } from "./UserProvider";

export function Providers({ children }: any) {
  return (
    <ThemeProvider>
      <UserProvider>
        <IntegrationsProvider>
          <AIProvider>{children}</AIProvider>
        </IntegrationsProvider>
      </UserProvider>
    </ThemeProvider>
  );
}
